import blog from "./blog";
import blog_slider from "./blog_slider";
import blog_sorting from "./blog_sorting";
import changeImagesOnScroll from "./changeImagesOnScroll";
import faq from "./faq";
import menu from "./menu";
import mini_contact_form from "./mini_contact_form";
import modals from "./modals";
import slider from "./slider";
import tabs from "./tabs";
import feedback_form from "./feedback_form";
import list_work from "./list_work";
import horizontal_tabs_nav from "./horizontal_tabs_nav";
import image_lightbox from "./image_lightbox";
import contact_animation from "./contact_animation";
import lazyLoader from "./lazyLoader";
import case_page from "./case_page";

export default function app() {
    document.addEventListener('DOMContentLoaded', () => {
        changeImagesOnScroll();
        menu();
        tabs();
        faq();
        slider();
        blog();
        modals();
        feedback_form();
        mini_contact_form();
        list_work();
        horizontal_tabs_nav();
        image_lightbox();
        contact_animation();
        lazyLoader();
        case_page();
    })
}



